import React from 'react';
import { Result } from 'antd';

export default function AllMatchedResult() {
  return (
    <Result
      status="success"
      title="All resources are matched"
      subTitle="All resources in this selection have an asset id, well done!"
    />
  );
}
